module.exports = __webpack_public_path__ + "img/crystal.72de992.jpg";